import React from "react";
import types from "./types";

const Template = ({ variant, size, color, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {variant === "outline" && (
      <path
        d="M3 2.992C3 2.444 3.445 2 3.993 2H20.007C20.2696 2.00183 20.521 2.1069 20.7068 2.29251C20.8926 2.47813 20.9979 2.72938 21 2.992V21.008C20.9997 21.2712 20.895 21.5235 20.7088 21.7095C20.5226 21.8955 20.2702 22 20.007 22H3.993C3.73038 21.9982 3.47902 21.8931 3.29322 21.7075C3.10742 21.5219 3.00209 21.2706 3 21.008V2.992ZM19 11V4H5V11H19ZM19 13H5V20H19V13ZM9 6H15V8H9V6ZM9 15H15V17H9V15Z"
        fill={color}
      />
    )}

    {variant === "default" && (
      <path
        d="M3 13H21V21.002C21 21.553 20.555 22 20.007 22H3.993C3.86225 21.9997 3.73284 21.9737 3.61215 21.9234C3.49147 21.8731 3.38188 21.7995 3.28966 21.7068C3.19744 21.6141 3.12439 21.5042 3.07469 21.3832C3.02499 21.2623 2.99961 21.1327 3 21.002V13ZM3 2.998C3 2.447 3.445 2 3.993 2H20.007C20.555 2 21 2.446 21 2.998V11H3V2.998ZM9 5V7H15V5H9ZM9 16V18H15V16H9Z"
        fill={color}
      />
    )}
  </svg>
);

Template.propTypes = types.propTypes;
Template.defaultProps = types.defaultProps;

export default Template;
